import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Servicio encargado de conectarse a la API para obtener los datos realcionados a los sensores
 */
export class IdEstacionService {
  idStationSource = new BehaviorSubject<string>(null);
  currentIdStation = this.idStationSource.asObservable();

  constructor() {}

  changeIdStationEstaciones(id: string) {
    this.idStationSource.next(id);
    console.log('service metricas', id);
  }
}
